import { render, staticRenderFns } from "./LockingLayer.vue?vue&type=template&id=a6d8a124"
import script from "./LockingLayer.vue?vue&type=script&lang=js"
export * from "./LockingLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports